// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --skeleton-base: #e3e3e3;
  --skeleton-highlight: #f4f4f2;
  --skeleton-gradient: linear-gradient(
    90deg,
    #e3e3e3 0%,
    #f4f4f2 50%,
    #e3e3e3 100%
  );
  --skeleton-panel-bg: var(--surface-primary, #ffffff);
  --skeleton-panel-border: var(--border-subtle, #e8e8e5);
}
[data-theme="dark"],
.dark,
html[data-theme="dark"] {
  --skeleton-base: #3b404a;
  --skeleton-highlight: #4c5360;
  --skeleton-gradient: linear-gradient(
    90deg,
    #3b404a 0%,
    #4c5360 50%,
    #3b404a 100%
  );
  --skeleton-panel-bg: var(--surface-primary, #191b1f);
  --skeleton-panel-border: var(--border-subtle, #343a3a);
}

/* Base Shimmer Skeleton */
.app-skeleton {
  display: block;
  max-width: 100%;
  min-height: 8px;
  border-radius: var(--radius-xs, 4px);
  background: var(--skeleton-gradient);
  background-size: 200% 100%;
  animation: app-skeleton-shimmer 1.5s ease-in-out infinite;
  box-sizing: border-box;
}

/* Variant Modifiers */
.app-skeleton--text {
  min-height: 12px;
  border-radius: var(--radius-xs, 4px);
}

.app-skeleton--circular {
  border-radius: var(--radius-full, 9999px) !important;
  aspect-ratio: 1 / 1;
}

.app-skeleton--pill {
  border-radius: var(--radius-pill, 999px) !important;
}

.app-skeleton--rounded {
  border-radius: var(--radius-sm, 8px) !important;
}

.app-skeleton--card {
  border-radius: var(--radius-md, 12px) !important;
}

.app-skeleton--pulse {
  animation: app-skeleton-pulse 1.8s ease-in-out infinite;
  background: var(--skeleton-base);
}

.app-skeleton--static {
  animation: none;
  background: var(--skeleton-base);
}

/* Shimmer Animation */
@keyframes app-skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

@keyframes app-skeleton-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.45;
  }
}

/* Reduced Motion Override */
@media (prefers-reduced-motion: reduce) {
  .app-skeleton {
    animation: none !important;
    background: var(--skeleton-base) !important;
  }
}

/* Accessibility */
.skeleton-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Text Skeleton Stack */
.app-skeleton-text-group {
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
}

/* Avatar Skeleton */
.app-skeleton-avatar {
  flex-shrink: 0;
  display: inline-block;
}

/* Card Skeletons */
.app-skeleton-card-panel {
  background: var(--skeleton-panel-bg);
  border: 1px solid var(--skeleton-panel-border);
  border-radius: var(--radius-lg, 14px);
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
  transition: background-color 0.2s, border-color 0.2s;
}

.app-skeleton-card--stat {
  min-height: 154px;
  gap: 14px;
  padding: 24px;
}

.app-skeleton-card--stat-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.app-skeleton-card--summary {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px 20px;
}

.app-skeleton-card--vendor {
  border-radius: var(--radius-md, 12px);
  overflow: hidden;
  padding: 1px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.app-skeleton-card--vendor-image {
  height: 180px;
  width: 100%;
  border-radius: var(--radius-sm, 8px);
}

.app-skeleton-card--vendor-content {
  padding: 12px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.app-skeleton-card--chart {
  min-height: 280px;
  padding: 24px;
}

/* Table Skeletons */
.app-skeleton-table-wrap {
  width: 100%;
  background: var(--skeleton-panel-bg);
  border: 1px solid var(--skeleton-panel-border);
  border-radius: var(--radius-md, 12px);
  overflow: hidden;
  box-sizing: border-box;
}

.app-skeleton-table-header-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid var(--skeleton-panel-border);
  gap: 16px;
}

.app-skeleton-table {
  width: 100%;
  border-collapse: collapse;
}

.app-skeleton-table th,
.app-skeleton-table td {
  padding: 14px 16px;
  text-align: left;
  vertical-align: middle;
  border-bottom: 1px solid var(--skeleton-panel-border);
}

.app-skeleton-table th {
  background: rgba(0, 0, 0, 0.02);
}

[data-theme="dark"] .app-skeleton-table th,
.dark .app-skeleton-table th {
  background: rgba(255, 255, 255, 0.02);
}

.app-skeleton-table tbody tr:last-child td {
  border-bottom: none;
}

/* Flex/Div Table Skeleton (for CSS register grids) */
.app-skeleton-row-stack {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.app-skeleton-row {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid var(--skeleton-panel-border);
  gap: 16px;
  width: 100%;
  box-sizing: border-box;
}

.app-skeleton-row:last-child {
  border-bottom: none;
}

/* Page Skeleton Layouts */
.app-skeleton-page {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  box-sizing: border-box;
  outline: none;
}

.app-skeleton-page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
}

.app-skeleton-page-header-titles {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.app-skeleton-page-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.app-skeleton-metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
  width: 100%;
}

.app-skeleton-filter-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 4px 0;
}

.app-skeleton-two-col {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 24px;
  width: 100%;
}

@media (max-width: 992px) {
  .app-skeleton-two-col {
    grid-template-columns: 1fr;
  }
}

.app-skeleton-form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 16px;
  width: 100%;
}

.app-skeleton-document-editor-grid,
.app-skeleton-document-detail-grid,
.app-skeleton-expense-editor-grid,
.app-skeleton-expense-detail-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  gap: 24px;
  width: 100%;
  align-items: start;
}

.app-skeleton-document-detail-grid {
  grid-template-columns: minmax(0, 1fr) 320px;
}

.app-skeleton-expense-editor-grid {
  grid-template-columns: minmax(0, 1fr) 320px;
}

.app-skeleton-expense-detail-grid {
  grid-template-columns: minmax(0, 1fr) 320px;
}

.app-skeleton-contact-tabs {
  display: flex;
  align-items: center;
  gap: 4px;
  border-bottom: 1px solid var(--skeleton-panel-border);
}

.app-skeleton-contact-page {
  --skeleton-base: var(--surface-secondary);
  --skeleton-highlight: var(--surface-tertiary);
  --skeleton-gradient: linear-gradient(
    90deg,
    var(--skeleton-base) 0%,
    var(--skeleton-highlight) 50%,
    var(--skeleton-base) 100%
  );
}

.app-skeleton-contact-header {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.app-skeleton-contact-back,
.app-skeleton-contact-name {
  display: flex;
  align-items: center;
  height: 40px;
}

.app-skeleton-contact-back { padding-inline: 12px; }
.app-skeleton-contact-page .app-skeleton-page-header { align-items: center; gap: 16px; }
.app-skeleton-contact-page .app-skeleton-inline-actions,
.app-skeleton-contact-page .app-skeleton-page-header-actions { justify-content: flex-start; gap: 8px; }

.app-skeleton-contact-tab {
  display: flex;
  align-items: center;
  min-width: 0;
  height: 44px;
  padding-inline: 16px;
  box-sizing: border-box;
}

.app-skeleton-contact-stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
}

.app-skeleton-contact-overview {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 378px;
  gap: 16px;
  align-items: start;
}

.app-skeleton-contact-page .app-skeleton-document-main { gap: 16px; }
.app-skeleton-contact-page .app-skeleton-document-sidebar { gap: 12px; }
.app-skeleton-contact-overview .app-skeleton-card-panel { gap: 14px; border-radius: var(--radius-md, 10px); }
.app-skeleton-contact-card-title { display: flex; align-items: center; height: 25.2px; }
.app-skeleton-contact-detail-list { display: flex; flex-direction: column; gap: 10px; }
.app-skeleton-contact-detail-list .app-skeleton-summary-row { min-height: 24px; }
.app-skeleton-contact-activity { display: flex; flex-direction: column; gap: 20px; margin-top: 4px; }
.app-skeleton-contact-activity-row { display: flex; align-items: flex-start; gap: 14px; min-height: 40px; }
.app-skeleton-contact-activity-row > .app-skeleton { flex-shrink: 0; }
.app-skeleton-contact-activity-text { display: flex; flex: 1 1; min-width: 0; flex-direction: column; justify-content: center; gap: 6px; min-height: 40px; }

.app-skeleton-document-main,
.app-skeleton-document-sidebar {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 24px;
}

.app-skeleton-document-fields,
.app-skeleton-document-meta-grid,
.app-skeleton-document-bottom-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.app-skeleton-field,
.app-skeleton-card-heading-row > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 8px;
}

.app-skeleton-card-heading-row,
.app-skeleton-summary-row,
.app-skeleton-inline-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.app-skeleton-document-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.app-skeleton-document-actions > :last-child {
  grid-column: 1 / -1;
}

@media (max-width: 1024px) {
  .app-skeleton-document-editor-grid,
  .app-skeleton-document-detail-grid,
  .app-skeleton-expense-editor-grid,
  .app-skeleton-expense-detail-grid {
    grid-template-columns: 1fr;
  }

  .app-skeleton-expense-page .app-skeleton-document-sidebar {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .app-skeleton-contact-stats,
  .app-skeleton-contact-overview {
    grid-template-columns: 1fr;
  }

  .app-skeleton-contact-stats { gap: 12px; }
}

@media (max-width: 700px) {
  .app-skeleton-document-fields,
  .app-skeleton-document-meta-grid,
  .app-skeleton-document-bottom-grid {
    grid-template-columns: 1fr;
  }

  .app-skeleton-document-page {
    gap: 16px;
  }

  .app-skeleton-document-main,
  .app-skeleton-document-sidebar {
    gap: 16px;
  }

  .app-skeleton-expense-page .app-skeleton-document-sidebar {
    grid-template-columns: 1fr;
  }

  .app-skeleton-document-page .app-skeleton-page-header-actions,
  .app-skeleton-expense-page .app-skeleton-page-header-actions {
    width: 100%;
    flex-wrap: wrap;
  }

  .app-skeleton-document-page .app-skeleton-page-header-actions > *,
  .app-skeleton-expense-page .app-skeleton-page-header-actions > * {
    flex: 1 1 112px;
  }

  .app-skeleton-card-heading-row {
    align-items: flex-start;
    flex-direction: column;
  }

  .app-skeleton-inline-actions {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
}

@media (max-width: 600px) {
  .app-skeleton-contact-page .app-skeleton-page-header { flex-direction: column; align-items: stretch; }
  .app-skeleton-contact-name { height: 26px; }
  .app-skeleton-contact-page .app-skeleton-page-header-actions { width: 100%; }
  .app-skeleton-contact-page .app-skeleton-page-header-actions > * { flex: 1 1; }
  .app-skeleton-contact-detail-list .app-skeleton-summary-row { flex-direction: column; align-items: flex-start; justify-content: center; gap: 8px; min-height: 44px; }
}

.app-skeleton-history {
  gap: 16px;
}

.app-skeleton-history-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  margin-top: 18px;
}

.app-skeleton-history-chip {
  display: flex;
  width: 330px;
  min-height: 66px;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid var(--skeleton-panel-border);
  border-radius: 12px;
  background: var(--skeleton-panel-bg);
}

.app-skeleton-history-chip > div {
  display: flex;
  min-width: 0;
  flex: 1 1;
  flex-direction: column;
  gap: 7px;
}

.app-skeleton-history-banner {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border-radius: 10px;
  background: var(--skeleton-panel-bg);
}

.app-skeleton-history-banner > div {
  display: flex;
  min-width: 0;
  flex: 1 1;
  flex-direction: column;
  gap: 8px;
}

.app-skeleton-history-workspace {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 340px;
  gap: 20px;
  align-items: start;
}

.app-skeleton-history-feed-panel,
.app-skeleton-history-note-panel {
  overflow: hidden;
  border: 1px solid var(--skeleton-panel-border);
  border-radius: 14px;
  background: var(--skeleton-panel-bg);
}

.app-skeleton-history-toolbar {
  display: flex;
  min-height: 71px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
  border-bottom: 1px solid var(--skeleton-panel-border);
}

.app-skeleton-history-toolbar > div {
  display: flex;
  gap: 6px;
}

.app-skeleton-history-events {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
}

.app-skeleton-history-event {
  display: flex;
  min-height: 108px;
  gap: 14px;
  padding: 16px;
  border: 1px solid var(--skeleton-panel-border);
  border-radius: 10px;
}

.app-skeleton-history-event > div {
  display: flex;
  min-width: 0;
  flex: 1 1;
  flex-direction: column;
  gap: 10px;
}

.app-skeleton-history-event > div > span {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.app-skeleton-history-note-panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
}

.app-skeleton-history-note-panel > .app-skeleton:last-child {
  align-self: flex-end;
}

@media (max-width: 980px) {
  .app-skeleton-history-workspace {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 720px) {
  .app-skeleton-history-header,
  .app-skeleton-history-toolbar {
    align-items: stretch;
    flex-direction: column;
  }

  .app-skeleton-history-chip {
    width: 100%;
  }

  .app-skeleton-history-toolbar > .app-skeleton {
    width: 100% !important;
  }
}
.document-preview-skeleton__body {
  grid-template-columns: minmax(0, 1fr) minmax(260px, 0.42fr);
}

.document-preview-skeleton__metadata {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

@media (max-width: 820px) {
  .document-preview-skeleton__header {
    flex-direction: column;
  }

  .document-preview-skeleton__body {
    grid-template-columns: minmax(0, 1fr);
  }

  .document-preview-skeleton__metadata {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/skeleton.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B;;;;;GAKC;EACD,oDAAoD;EACpD,sDAAsD;AACxD;AACA;;;EAGE,wBAAwB;EACxB,6BAA6B;EAC7B;;;;;GAKC;EACD,oDAAoD;EACpD,sDAAsD;AACxD;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,oCAAoC;EACpC,oCAAoC;EACpC,0BAA0B;EAC1B,yDAAyD;EACzD,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,oDAAoD;EACpD,mBAAmB;AACrB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,uDAAuD;EACvD,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,0BAA0B;IAC1B,2CAA2C;EAC7C;AACF;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,oCAAoC;EACpC,8CAA8C;EAC9C,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oDAAoD;AACtD;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,oCAAoC;EACpC,8CAA8C;EAC9C,qCAAqC;EACrC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,qDAAqD;EACrD,SAAS;AACX;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,qDAAqD;AACvD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qDAAqD;EACrD,SAAS;EACT,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,WAAW;AACb;;AAEA;;;;EAIE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qDAAqD;AACvD;;AAEA;EACE,yCAAyC;EACzC,6CAA6C;EAC7C;;;;;GAKC;AACH;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA,6BAA6B,oBAAoB,EAAE;AACnD,uDAAuD,mBAAmB,EAAE,SAAS,EAAE;AACvF;+DAC+D,2BAA2B,EAAE,QAAQ,EAAE;;AAEtG;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA,yDAAyD,SAAS,EAAE;AACpE,4DAA4D,SAAS,EAAE;AACvE,0DAA0D,SAAS,EAAE,qCAAqC,EAAE;AAC5G,mCAAmC,aAAa,EAAE,mBAAmB,EAAE,cAAc,EAAE;AACvF,oCAAoC,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACtF,8DAA8D,gBAAgB,EAAE;AAChF,iCAAiC,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,eAAe,EAAE;AACpG,qCAAqC,aAAa,EAAE,uBAAuB,EAAE,SAAS,EAAE,gBAAgB,EAAE;AAC1G,qDAAqD,cAAc,EAAE;AACrE,sCAAsC,aAAa,EAAE,SAAO,EAAE,YAAY,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,QAAQ,EAAE,gBAAgB,EAAE;;AAEzJ;;EAEE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;EAGE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;;;;IAIE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,gDAAgD;EAClD;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA,8BAA8B,SAAS,EAAE;AAC3C;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,SAAS;EACX;;EAEA;;IAEE,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;IAC3B,eAAe;EACjB;AACF;;AAEA;EACE,uDAAuD,sBAAsB,EAAE,oBAAoB,EAAE;EACrG,6BAA6B,YAAY,EAAE;EAC3C,+DAA+D,WAAW,EAAE;EAC5E,mEAAmE,SAAO,EAAE;EAC5E,8DAA8D,sBAAsB,EAAE,uBAAuB,EAAE,uBAAuB,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AACtK;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,8CAA8C;EAC9C,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAO;EACP,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAO;EACP,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,8CAA8C;EAC9C,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,aAAa;EACb,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAO;EACP,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;IAEE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;AACF;AACA;EACE,2DAA2D;AAC7D;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,gDAAgD;EAClD;AACF","sourcesContent":[":root {\n  --skeleton-base: #e3e3e3;\n  --skeleton-highlight: #f4f4f2;\n  --skeleton-gradient: linear-gradient(\n    90deg,\n    #e3e3e3 0%,\n    #f4f4f2 50%,\n    #e3e3e3 100%\n  );\n  --skeleton-panel-bg: var(--surface-primary, #ffffff);\n  --skeleton-panel-border: var(--border-subtle, #e8e8e5);\n}\n[data-theme=\"dark\"],\n.dark,\nhtml[data-theme=\"dark\"] {\n  --skeleton-base: #3b404a;\n  --skeleton-highlight: #4c5360;\n  --skeleton-gradient: linear-gradient(\n    90deg,\n    #3b404a 0%,\n    #4c5360 50%,\n    #3b404a 100%\n  );\n  --skeleton-panel-bg: var(--surface-primary, #191b1f);\n  --skeleton-panel-border: var(--border-subtle, #343a3a);\n}\n\n/* Base Shimmer Skeleton */\n.app-skeleton {\n  display: block;\n  max-width: 100%;\n  min-height: 8px;\n  border-radius: var(--radius-xs, 4px);\n  background: var(--skeleton-gradient);\n  background-size: 200% 100%;\n  animation: app-skeleton-shimmer 1.5s ease-in-out infinite;\n  box-sizing: border-box;\n}\n\n/* Variant Modifiers */\n.app-skeleton--text {\n  min-height: 12px;\n  border-radius: var(--radius-xs, 4px);\n}\n\n.app-skeleton--circular {\n  border-radius: var(--radius-full, 9999px) !important;\n  aspect-ratio: 1 / 1;\n}\n\n.app-skeleton--pill {\n  border-radius: var(--radius-pill, 999px) !important;\n}\n\n.app-skeleton--rounded {\n  border-radius: var(--radius-sm, 8px) !important;\n}\n\n.app-skeleton--card {\n  border-radius: var(--radius-md, 12px) !important;\n}\n\n.app-skeleton--pulse {\n  animation: app-skeleton-pulse 1.8s ease-in-out infinite;\n  background: var(--skeleton-base);\n}\n\n.app-skeleton--static {\n  animation: none;\n  background: var(--skeleton-base);\n}\n\n/* Shimmer Animation */\n@keyframes app-skeleton-shimmer {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n@keyframes app-skeleton-pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.45;\n  }\n}\n\n/* Reduced Motion Override */\n@media (prefers-reduced-motion: reduce) {\n  .app-skeleton {\n    animation: none !important;\n    background: var(--skeleton-base) !important;\n  }\n}\n\n/* Accessibility */\n.skeleton-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* Text Skeleton Stack */\n.app-skeleton-text-group {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Avatar Skeleton */\n.app-skeleton-avatar {\n  flex-shrink: 0;\n  display: inline-block;\n}\n\n/* Card Skeletons */\n.app-skeleton-card-panel {\n  background: var(--skeleton-panel-bg);\n  border: 1px solid var(--skeleton-panel-border);\n  border-radius: var(--radius-lg, 14px);\n  padding: 20px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  transition: background-color 0.2s, border-color 0.2s;\n}\n\n.app-skeleton-card--stat {\n  min-height: 154px;\n  gap: 14px;\n  padding: 24px;\n}\n\n.app-skeleton-card--stat-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.app-skeleton-card--summary {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 16px 20px;\n}\n\n.app-skeleton-card--vendor {\n  border-radius: var(--radius-md, 12px);\n  overflow: hidden;\n  padding: 1px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.app-skeleton-card--vendor-image {\n  height: 180px;\n  width: 100%;\n  border-radius: var(--radius-sm, 8px);\n}\n\n.app-skeleton-card--vendor-content {\n  padding: 12px 16px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.app-skeleton-card--chart {\n  min-height: 280px;\n  padding: 24px;\n}\n\n/* Table Skeletons */\n.app-skeleton-table-wrap {\n  width: 100%;\n  background: var(--skeleton-panel-bg);\n  border: 1px solid var(--skeleton-panel-border);\n  border-radius: var(--radius-md, 12px);\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.app-skeleton-table-header-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--skeleton-panel-border);\n  gap: 16px;\n}\n\n.app-skeleton-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.app-skeleton-table th,\n.app-skeleton-table td {\n  padding: 14px 16px;\n  text-align: left;\n  vertical-align: middle;\n  border-bottom: 1px solid var(--skeleton-panel-border);\n}\n\n.app-skeleton-table th {\n  background: rgba(0, 0, 0, 0.02);\n}\n\n[data-theme=\"dark\"] .app-skeleton-table th,\n.dark .app-skeleton-table th {\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.app-skeleton-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* Flex/Div Table Skeleton (for CSS register grids) */\n.app-skeleton-row-stack {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.app-skeleton-row {\n  display: flex;\n  align-items: center;\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--skeleton-panel-border);\n  gap: 16px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.app-skeleton-row:last-child {\n  border-bottom: none;\n}\n\n/* Page Skeleton Layouts */\n.app-skeleton-page {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 100%;\n  box-sizing: border-box;\n  outline: none;\n}\n\n.app-skeleton-page-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.app-skeleton-page-header-titles {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.app-skeleton-page-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.app-skeleton-metrics-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 16px;\n  width: 100%;\n}\n\n.app-skeleton-filter-bar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 4px 0;\n}\n\n.app-skeleton-two-col {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 24px;\n  width: 100%;\n}\n\n@media (max-width: 992px) {\n  .app-skeleton-two-col {\n    grid-template-columns: 1fr;\n  }\n}\n\n.app-skeleton-form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 16px;\n  width: 100%;\n}\n\n.app-skeleton-document-editor-grid,\n.app-skeleton-document-detail-grid,\n.app-skeleton-expense-editor-grid,\n.app-skeleton-expense-detail-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 360px;\n  gap: 24px;\n  width: 100%;\n  align-items: start;\n}\n\n.app-skeleton-document-detail-grid {\n  grid-template-columns: minmax(0, 1fr) 320px;\n}\n\n.app-skeleton-expense-editor-grid {\n  grid-template-columns: minmax(0, 1fr) 320px;\n}\n\n.app-skeleton-expense-detail-grid {\n  grid-template-columns: minmax(0, 1fr) 320px;\n}\n\n.app-skeleton-contact-tabs {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  border-bottom: 1px solid var(--skeleton-panel-border);\n}\n\n.app-skeleton-contact-page {\n  --skeleton-base: var(--surface-secondary);\n  --skeleton-highlight: var(--surface-tertiary);\n  --skeleton-gradient: linear-gradient(\n    90deg,\n    var(--skeleton-base) 0%,\n    var(--skeleton-highlight) 50%,\n    var(--skeleton-base) 100%\n  );\n}\n\n.app-skeleton-contact-header {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.app-skeleton-contact-back,\n.app-skeleton-contact-name {\n  display: flex;\n  align-items: center;\n  height: 40px;\n}\n\n.app-skeleton-contact-back { padding-inline: 12px; }\n.app-skeleton-contact-page .app-skeleton-page-header { align-items: center; gap: 16px; }\n.app-skeleton-contact-page .app-skeleton-inline-actions,\n.app-skeleton-contact-page .app-skeleton-page-header-actions { justify-content: flex-start; gap: 8px; }\n\n.app-skeleton-contact-tab {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  height: 44px;\n  padding-inline: 16px;\n  box-sizing: border-box;\n}\n\n.app-skeleton-contact-stats {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 24px;\n}\n\n.app-skeleton-contact-overview {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 378px;\n  gap: 16px;\n  align-items: start;\n}\n\n.app-skeleton-contact-page .app-skeleton-document-main { gap: 16px; }\n.app-skeleton-contact-page .app-skeleton-document-sidebar { gap: 12px; }\n.app-skeleton-contact-overview .app-skeleton-card-panel { gap: 14px; border-radius: var(--radius-md, 10px); }\n.app-skeleton-contact-card-title { display: flex; align-items: center; height: 25.2px; }\n.app-skeleton-contact-detail-list { display: flex; flex-direction: column; gap: 10px; }\n.app-skeleton-contact-detail-list .app-skeleton-summary-row { min-height: 24px; }\n.app-skeleton-contact-activity { display: flex; flex-direction: column; gap: 20px; margin-top: 4px; }\n.app-skeleton-contact-activity-row { display: flex; align-items: flex-start; gap: 14px; min-height: 40px; }\n.app-skeleton-contact-activity-row > .app-skeleton { flex-shrink: 0; }\n.app-skeleton-contact-activity-text { display: flex; flex: 1; min-width: 0; flex-direction: column; justify-content: center; gap: 6px; min-height: 40px; }\n\n.app-skeleton-document-main,\n.app-skeleton-document-sidebar {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.app-skeleton-document-fields,\n.app-skeleton-document-meta-grid,\n.app-skeleton-document-bottom-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.app-skeleton-field,\n.app-skeleton-card-heading-row > div {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.app-skeleton-card-heading-row,\n.app-skeleton-summary-row,\n.app-skeleton-inline-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.app-skeleton-document-actions {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.app-skeleton-document-actions > :last-child {\n  grid-column: 1 / -1;\n}\n\n@media (max-width: 1024px) {\n  .app-skeleton-document-editor-grid,\n  .app-skeleton-document-detail-grid,\n  .app-skeleton-expense-editor-grid,\n  .app-skeleton-expense-detail-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .app-skeleton-expense-page .app-skeleton-document-sidebar {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .app-skeleton-contact-stats,\n  .app-skeleton-contact-overview {\n    grid-template-columns: 1fr;\n  }\n\n  .app-skeleton-contact-stats { gap: 12px; }\n}\n\n@media (max-width: 700px) {\n  .app-skeleton-document-fields,\n  .app-skeleton-document-meta-grid,\n  .app-skeleton-document-bottom-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .app-skeleton-document-page {\n    gap: 16px;\n  }\n\n  .app-skeleton-document-main,\n  .app-skeleton-document-sidebar {\n    gap: 16px;\n  }\n\n  .app-skeleton-expense-page .app-skeleton-document-sidebar {\n    grid-template-columns: 1fr;\n  }\n\n  .app-skeleton-document-page .app-skeleton-page-header-actions,\n  .app-skeleton-expense-page .app-skeleton-page-header-actions {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .app-skeleton-document-page .app-skeleton-page-header-actions > *,\n  .app-skeleton-expense-page .app-skeleton-page-header-actions > * {\n    flex: 1 1 112px;\n  }\n\n  .app-skeleton-card-heading-row {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .app-skeleton-inline-actions {\n    justify-content: flex-start;\n    flex-wrap: wrap;\n  }\n}\n\n@media (max-width: 600px) {\n  .app-skeleton-contact-page .app-skeleton-page-header { flex-direction: column; align-items: stretch; }\n  .app-skeleton-contact-name { height: 26px; }\n  .app-skeleton-contact-page .app-skeleton-page-header-actions { width: 100%; }\n  .app-skeleton-contact-page .app-skeleton-page-header-actions > * { flex: 1; }\n  .app-skeleton-contact-detail-list .app-skeleton-summary-row { flex-direction: column; align-items: flex-start; justify-content: center; gap: 8px; min-height: 44px; }\n}\n\n.app-skeleton-history {\n  gap: 16px;\n}\n\n.app-skeleton-history-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 24px;\n  margin-top: 18px;\n}\n\n.app-skeleton-history-chip {\n  display: flex;\n  width: 330px;\n  min-height: 66px;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  border: 1px solid var(--skeleton-panel-border);\n  border-radius: 12px;\n  background: var(--skeleton-panel-bg);\n}\n\n.app-skeleton-history-chip > div {\n  display: flex;\n  min-width: 0;\n  flex: 1;\n  flex-direction: column;\n  gap: 7px;\n}\n\n.app-skeleton-history-banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 16px;\n  border-radius: 10px;\n  background: var(--skeleton-panel-bg);\n}\n\n.app-skeleton-history-banner > div {\n  display: flex;\n  min-width: 0;\n  flex: 1;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.app-skeleton-history-workspace {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 340px;\n  gap: 20px;\n  align-items: start;\n}\n\n.app-skeleton-history-feed-panel,\n.app-skeleton-history-note-panel {\n  overflow: hidden;\n  border: 1px solid var(--skeleton-panel-border);\n  border-radius: 14px;\n  background: var(--skeleton-panel-bg);\n}\n\n.app-skeleton-history-toolbar {\n  display: flex;\n  min-height: 71px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 16px;\n  border-bottom: 1px solid var(--skeleton-panel-border);\n}\n\n.app-skeleton-history-toolbar > div {\n  display: flex;\n  gap: 6px;\n}\n\n.app-skeleton-history-events {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 16px;\n}\n\n.app-skeleton-history-event {\n  display: flex;\n  min-height: 108px;\n  gap: 14px;\n  padding: 16px;\n  border: 1px solid var(--skeleton-panel-border);\n  border-radius: 10px;\n}\n\n.app-skeleton-history-event > div {\n  display: flex;\n  min-width: 0;\n  flex: 1;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.app-skeleton-history-event > div > span {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.app-skeleton-history-note-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 20px;\n}\n\n.app-skeleton-history-note-panel > .app-skeleton:last-child {\n  align-self: flex-end;\n}\n\n@media (max-width: 980px) {\n  .app-skeleton-history-workspace {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 720px) {\n  .app-skeleton-history-header,\n  .app-skeleton-history-toolbar {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .app-skeleton-history-chip {\n    width: 100%;\n  }\n\n  .app-skeleton-history-toolbar > .app-skeleton {\n    width: 100% !important;\n  }\n}\n.document-preview-skeleton__body {\n  grid-template-columns: minmax(0, 1fr) minmax(260px, 0.42fr);\n}\n\n.document-preview-skeleton__metadata {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n@media (max-width: 820px) {\n  .document-preview-skeleton__header {\n    flex-direction: column;\n  }\n\n  .document-preview-skeleton__body {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .document-preview-skeleton__metadata {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
